import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    clearError,
    saveLookNew,
    stylingRoomClearResult} from 'redux/reducers/stylingRoom/actions';
import { changeModal,toggleModal } from 'store/ui/actions';

import SavePersonalShopping from './SavePersonalShopping';

const mapStateToProps = ({
    ui: { redirectUrl },
    style: { loading },
    stylingRoom: { loading: stylingRoomLoading, result, gender, styleRequest, error }
}) => ({
    loading,
    stylingRoomLoading,
    styleRequest,
    result,
    gender,
    redirectUrl,
    error
});

const mapDispatchToProps = (dispatch) => ({
    saveLook: (info) => dispatch(saveLookNew(info, 'ps')),
    clearResult: () => dispatch(stylingRoomClearResult()),
    toggleModal: (data) => toggleModal(dispatch, data),
    changeModal: (data) => changeModal(dispatch, data),
    clearError: () => dispatch(clearError(dispatch))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SavePersonalShopping));
